/* Lexington standard mantels only. Real $175 service line, never a cosmetic fee. */
(() => {
  function init() {
    const panel = document.getElementById('ef-standard-liftgate');
    const form = panel?.closest('form');
    if (!form || panel.dataset.bound) return;
    panel.dataset.bound = 'true';
    const main = form.querySelector('#efUniATC');
    const express = form.querySelector('#efUniExpressCheckout');
    const variants = JSON.parse(document.getElementById('efUniVariantsData').textContent);
    const feeId = Number(panel.dataset.feeVariant);
    const summary = panel.querySelector('[data-liftgate-total]');
    const choice = () => panel.querySelector('input:checked')?.value;
    const variant = () => variants.find(v => String(v.id) === form.querySelector('[name="id"]').value);
    const quantity = () => Math.min(99, Math.max(1, parseInt(form.querySelector('[name="quantity"]').value, 10) || 1));
    const money = n => '$' + (n / 100).toLocaleString('en-US', {maximumFractionDigits:2});
    let busy = false;
    function sync() {
      const v = variant();
      const message = !choice() ? 'Select a delivery option above.' : !v ? 'Choose an available width.' : 'Total: ' + money(v.price * quantity() + (choice() === 'yes' ? 17500 : 0)) + (choice() === 'yes' ? ' — includes $175 liftgate delivery' : ' — no liftgate charge');
      if(summary.textContent !== message) summary.textContent = message;
      if(v?.available && !busy && choice()) {
        const label=main.querySelector('[data-atc-text]');
        const text='Add to Cart — '+money(v.price*quantity()+(choice()==='yes'?17500:0));
        if(label && label.textContent!==text)label.textContent=text;
      }
    }
    async function add(checkout) {
      if(busy || form.dataset.efUniCartPending === 'true') return;
      if(!form.reportValidity()) return;
      const v = variant(); if(!v?.available || main.disabled) return;
      busy = true; form.dataset.efUniCartPending = 'true'; form.setAttribute('aria-busy','true');
      form.dispatchEvent(new Event('ef:uni-cart-state'));
      panel.disabled = true;
      try {
        const items = [{id:v.id,quantity:quantity(),properties:{'Liftgate delivery':choice() === 'yes' ? 'Yes (+$175)' : 'No — customer can unload'}}];
        if(choice() === 'yes') {
          const cartResponse=await fetch('/cart.js');if(!cartResponse.ok)throw Error('cart');
          const cart=await cartResponse.json();
          if(!cart.items.some(item=>item.variant_id===feeId))items.push({id:feeId,quantity:1,properties:{Service:'Liftgate delivery for Lexington mantel'}});
        }
        const response = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json(); if(!response.ok || !result.items?.length) throw Error('cart');
        if(checkout) {location.href='/checkout';return;}
        if(window.EFCartDrawer?.open) window.EFCartDrawer.open(); else location.href='/cart';
      } catch(_) {
        if(form._efUniShowCartError) form._efUniShowCartError("We couldn’t confirm whether your mantel was added. Check your cart before trying again.");
        else summary.textContent='Please check your cart before trying again, or call (949) 619-7824.';
      } finally {
        busy=false;panel.disabled=false;form.dataset.efUniCartPending='false';form.setAttribute('aria-busy','false');form.dispatchEvent(new Event('ef:uni-cart-state'));sync();
      }
    }
    form.addEventListener('submit',e=>{e.preventDefault();e.stopImmediatePropagation();add(false);},true);
    if(express)express.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();add(true);},true);
    ['change','input','click'].forEach(type=>form.addEventListener(type,()=>requestAnimationFrame(sync)));
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
